const RolesSettingsForm = {
  fields: {
    oit: {
      type: 'text',
      label: 'OIT Label',
    },
    oit_short: {
      type: 'text',
      label: 'OIT short Label',
    },
    fto: {
      type: 'text',
      label: 'FTO Label',
    },
    fto_short: {
      type: 'text',
      label: 'FTO short Label',
    },
    ftoc: {
      type: 'text',
      label: 'FTO coordinator Label',
    },
    ftoc_short: {
      type: 'text',
      label: 'FTO coordinator short Label',
    },
    sup: {
      type: 'text',
      label: 'Supervisor label',
    },
    sup_short: {
      type: 'text',
      label: 'Supervisor short label',
    },
    cstaff: {
      type: 'text',
      label: 'Command staff label',
    },
    cstaff_short: {
      type: 'text',
      label: 'Command staff short label',
    },
    chief: {
      type: 'text',
      label: 'Chief label',
    },
    chief_short: {
      type: 'text',
      label: 'Chief short label',
    },
    depadmin: {
      type: 'text',
      label: 'Department admin label',
    },
    depadmin_short: {
      type: 'text',
      label: 'Department admin short label',
    },
  }
};

const MainDepartmentNameForm = {
  fields: {
    mainDepartment: {
      type: 'text',
      label: 'Main department name',
    },
  }
};

export {
  RolesSettingsForm,
  MainDepartmentNameForm
}
